import { useState } from 'react';

interface Props {
  q: string;
  a: string;
}

export default function FaqItem({ q, a }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`rounded-xl border transition-all duration-200 overflow-hidden ${open ? 'border-[#3B9EE8]/40 bg-white' : 'border-[#0A1628]/8 bg-white hover:border-[#3B9EE8]/25'}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
        <span className={`font-500 text-sm pr-8 leading-snug ${open ? 'text-[#0A1628] font-600' : 'text-[#0A1628]/80'}`}>{q}</span>
        <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${open ? 'bg-[#3B9EE8] rotate-45' : 'bg-[#0A1628]/6'}`}>
          <i className={`ri-add-line text-xs ${open ? 'text-white' : 'text-[#0A1628]/60'}`} />
        </div>
      </button>
      {open && (
        <div className="px-6 pb-5 border-t border-[#3B9EE8]/15">
          <p className="text-[#0A1628]/65 text-sm leading-relaxed pt-4">{a}</p>
        </div>
      )}
    </div>
  );
}
